import { EXCLUDED_ITEMS_FROM_CHECKLIST } from "../constants/product.constants";

export const transformOptionsData = (data) => {
  return data.reduce((acc, item) => {
    const { field, options } = item;

    if (!acc[field]) {
      acc[field] = [];
    }

    acc[field].push({ option: options });
    return acc;
  }, {});
};
export const counterForChecklist = (checklist) => {
  const result = { done: 0, total: 0 };
  for (let item in checklist) {
    if (!EXCLUDED_ITEMS_FROM_CHECKLIST.includes(item)) {
      if (
        (typeof checklist?.[item] !== "object" && checklist?.[item]) ||
        (typeof checklist?.[item] === "object" && checklist?.[item]?.length > 0)
      ) {
        result.done++;
      }
      result.total++;
    }
  }
  return result;
};
